


















import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { PuntosPeligroState } from '@/store/modules/puntos-peligro/types'
import { EtiquetaApi } from '@/domain/entities/Api'
import { getEnvironments } from '@/environments'
const env = getEnvironments()

@Component
export default class PuntosPeligroControl extends Vue {
  @Getter('getPuntosPeligro', { namespace: 'puntosPeligro' })
  getPuntosPeligro!: PuntosPeligroState
  @Action('setPosition', { namespace: 'googleMaps' })
  setPosition: any

  path: string = '/puntos-peligro'
  currentItem: number = 0
  unwatch: any;

  created () {
    if (this.isSubmenuSelected) {
      const position = env.settings.PUNTOS_PELIGRO.center
      const zoom = env.settings.PUNTOS_PELIGRO.zoom
      this.setPosition({ position, zoom })
    }
    this.currentItem = Number(this.$router.currentRoute.query.region || 0)
    this.unwatch = this.$store.watch(
      (state, getters) => state.puntosPeligro.isLoaded,
      (newValue, oldValue) => {
        if (newValue) {
          const selectedItem = this.selectedItem
          Number(this.$route.query.region) !== selectedItem.id &&
            this.$router.push({ query: { region: selectedItem.id } })
          this.unwatch()
        }
      }
    )
  }

  beforeUpdate () {
    const selectedItem = this.selectedItem
    if (this.getPuntosPeligro.isLoaded &&
      selectedItem != null &&
      this.$route.path === this.path &&
      Number(this.$route.query.region) !== selectedItem.id) {
      this.$router.push({ query: { region: this.selectedItem.id } })
    }
  }

  get selectedItem () {
    return this.computedEtiquetaList.filter((item) => item.id === this.currentItem)[0] || {}
  }

  get computedEtiquetaList (): any [] {
    if (this.getPuntosPeligro && this.getPuntosPeligro.punto_peligro_list.length > 0) {
      return this.getPuntosPeligro.punto_peligro_list
    } else {
      return []
    }
  }
  get isSubmenuSelected () {
    return this.$route.path === '/puntos-peligro'
  }
}
